import { render, staticRenderFns } from "./groupProduct.vue?vue&type=template&id=07558522&"
import script from "./groupProduct.vue?vue&type=script&lang=js&"
export * from "./groupProduct.vue?vue&type=script&lang=js&"
import style0 from "./groupProduct.vue?vue&type=style&index=0&id=07558522&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports